module.exports = __webpack_public_path__ + "media/134.b9167185.wav";